export const GET_QUESTIONS_LIST = 'GET_QUESTIONS_LIST';
export const GET_QUESTIONS_LOADING = 'GET_QUESTIONS_LOADING';
export const GET_QUESTIONS_ERROR = 'GET_QUESTIONS_ERROR';
export const GET_SUCCESS = 'GET_QUESTIONS_ACTIONS_COMPLETED';
export const GET_UPLOAD_FILE_LOADING = 'GET_UPLOAD_FILE_LOADING';
export const GET_UPLOAD_FILE = 'GET_UPLOAD_FILE';
